import cfiLogic from '../../cfiLogic';

/**
 * @method getElementForCfi
 */
const getElementForCfi = (frame, cfi) => {
  if (!cfi) {
    throw new Error('cfi is required');
  }

  const frameDocument = frame.contentDocument;

  // Try to compute a cfi for the element using the document.
  try {
    return cfiLogic.getElementForCfi(frameDocument, cfi);
  } catch (error) {
    console.warn('Failed to compute element from cfi.', cfi, error);
    return;
  }
};

export default getElementForCfi;
